import { define } from "../preactement/define";
import { Spinner } from "../../Spinner";
import { parseBooleanAttr } from "../wrapperUtils";
import { jsx as _jsx } from "preact/compat/jsx-runtime";
const attributes = ['aria-valuetext', 'class-name', 'inversed', 'filled', 'role', 'size'];

/* eslint-disable @typescript-eslint/no-namespace */

/* eslint-enable */

const Wrapper = _ref => {
  let {
    ariaValuetext,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/_jsx(Spinner, {
    ...otherProps,
    "aria-valuetext": ariaValuetext,
    inversed: parseBooleanAttr(otherProps.inversed),
    filled: parseBooleanAttr(otherProps.filled)
  });
};
define('ds-spinner', () => Wrapper, {
  attributes
});